module.exports = __webpack_public_path__ + "0fbfe9640d0dfcba61d49dc6a3e8f38d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/welcome-images/images/welcome-diamond.png
// module id = 334
// module chunks = 0